<template>
  <div class="main" v-if="loaded">
    <div class="content">
      <div class="header">
        <div>Bộ số</div>
        <div>Số lần xuất hiện</div>
      </div>
      <div class="item" v-for="item in stats" :key="item">
        <div class="number">{{ String(item.num).padStart(2, '0') }}</div>
        <div class="range" :style="'width: '+item.percentage + '%'"></div>
        <div class="count">{{ item.freq }}</div>
      </div>
    </div>
  </div>
  <div v-else style="color: #999">
    <div style="text-align: center; margin-top: 10vh">
      Đang tải dữ liệu..
    </div>
    <div style="text-align: center">
      Vui lòng chờ
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .main {
    padding: 1vw;
    .content {
      margin-top: 1vh;
      display: grid;
      .header {
        display: grid;
        grid-template-columns: auto auto;
        color: #555;
        margin-bottom: 1vh;
        div {
          &:nth-child(odd) {
            justify-self: start;
          }
          &:nth-child(even) {
            justify-self: end;
          }
        }
      }
      .item {
        display: grid;
        grid-template-columns: 10% auto 10%;
        text-align: center;
        align-items: center;
        margin: 0.5vh 0;
        .number {
          justify-self: center;
          background: #f60;
          border: 1px solid #f60;
          color: #fff;
          border-radius: 50%;
          width: 8vw;
          height: 8vw;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .range {
          overflow: visible;
          white-space: nowrap;
          background-color: #ffcb95;
          border-radius: 4px;
          color: #333;
          height: 1vh
        }
      }
    }
  }
</style>

<script>
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'PowerStats',
    components: {
    },
    mounted() {
      setTimeout(() => {
        this.$utils.callAPI('GET', '/stats/power', null, false).then((resp) => {
          this.stats = resp.data.stats;
          this.$nextTick(() => {
            this.loaded = true;
          });
        });
      }, 1000)
    },
    data() {
      return {
        loaded: false,
        stats: []
      }
    }
  })
</script>
